import { render } from "./Presses.vue?vue&type=template&id=38bda6b5&scoped=true"
import script from "./Presses.vue?vue&type=script&lang=js"
export * from "./Presses.vue?vue&type=script&lang=js"

import "./Presses.vue?vue&type=style&index=0&id=38bda6b5&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bda6b5"]])

export default __exports__